<div
  #selectRef
  class="select"
  [class.select--invalid]="settings?.required && !selectedOption"
  [class.select--filtro]="variante === 'filtro'"
  [class.select--has-value]="selectedOption !== null"
  [class.select--open]="isOpen"
>
  <div
    class="select__container"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="open()"
  >
    <span class="select__input-icon" *ngIf="exibirIcone" aria-hidden="true">
      <i class="fas" [ngClass]="icon"></i>
    </span>

    <ng-container
      *ngIf="customOptionTemplate && selectedOption; else defaultInput"
    >
      <div
        class="select__input select__input--custom"
        [class.select__input--disabled]="disabled"
      >
        <!-- Sem guarda pelo `id`: `0` é id válido em catálogo que começa no
             zero, e testá-lo por verdade apagava a opção escolhida do campo.
             O `selectedOption` do ngIf acima já garante o que renderizar. -->
        <ng-container
          *ngTemplateOutlet="
            customOptionTemplate;
            context: { $implicit: selectedOption }
          "
        ></ng-container>
      </div>
    </ng-container>
    <ng-template #defaultInput>
      <input
        readonly
        type="text"
        [value]="selectedOption?.label"
        class="select__input"
        [placeholder]="
          settings.required ? settings.placeholder + ' *' : settings.placeholder
        "
        [disabled]="disabled"
        [required]="settings.required"
      />
    </ng-template>
    <span
      *ngIf="
        selectedOption?.id != null &&
        !disabled &&
        settings.isClearSelectionAllowed
      "
      (click)="clearSelection($event)"
      class="select__input-clear"
    >
      <i class="fas fa-times"></i>
    </span>
    <span class="select__input-close">
      <i
        class="fas"
        [ngClass]="{
          'fa-chevron-up': isOpen,
          'fa-chevron-down': !isOpen
        }"
      ></i>
    </span>
  </div>

</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPanelClass]="overlayPanelClasses"
  (overlayOutsideClick)="onOverlayOutsideClick($event)"
  (detach)="onOverlayDetach()"
>
  <ul class="select__dropdown"
    [style.--largura-do-trigger.px]="larguraDoTrigger"
    [style.--altura-maxima-dropdown.px]="overlayMaxHeight">
    <li class="select__dropdown-loading" *ngIf="settings?.isLoading">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <span>Carregando...</span>
    </li>

    <ng-container *ngIf="!settings?.isLoading">
      <li class="select__dropdown-search" *ngIf="settings?.hasSearchField && options.length">
        <i class="fas fa-search select__dropdown-search-icon" aria-hidden="true"></i>
        <input
          #searchInputRef
          type="text"
          placeholder="Pesquisar..."
          [value]="searchText"
          (input)="searchText = searchInputRef.value"
        />
        <button
          *ngIf="searchText"
          type="button"
          class="select__dropdown-search-clear"
          aria-label="Limpar busca"
          (click)="clearSearch()"
        >
          <i class="fas fa-times"></i>
        </button>
      </li>

      <ng-container *ngIf="filteredOptions.length > 0; else emptyOptions">
        <li
          class="select__dropdown-option"
          *ngFor="let option of filteredOptions"
          (click)="selectOption(option)"
          title="{{ option.label }}"
          [class.select__dropdown-option--selected]="
            option?.id === selectedOption?.id
          "
        >
          <ng-container *ngIf="customOptionTemplate; else defaultLabel">
            <ng-container
              *ngTemplateOutlet="
                customOptionTemplate;
                context: { $implicit: option }
              "
            >
            </ng-container>
          </ng-container>
          <ng-template #defaultLabel>
            <icon *ngIf="option.icon" class="fas" [ngClass]="option.icon"></icon>
            <a>{{ option.label }}</a>
          </ng-template>
        </li>
      </ng-container>

      <ng-template #emptyOptions>
        <li class="select__dropdown-empty">
          {{
            searchText.trim() && options.length
              ? settings?.searchEmptyResultMessage
              : settings?.emptyResultMessage
          }}
        </li>
      </ng-template>
    </ng-container>
  </ul>
</ng-template>

<div *ngIf="settings.required && !selectedOption" class="select__error">
  {{ settings.requiredFieldMessage }}
</div>
